module.exports = __webpack_public_path__ + "static/media/foto_3.96b10648.png";